import { LinkButton } from '@stories/Components/Buttons/GeneralButton/Button';
import React from 'react';
import S from './SiteFooter.styles';
const SiteFooter = ({ address, baseNav, copyright, ctas, email, logo, nav, social, tel, }) => {
    return (React.createElement(S.Container, null,
        React.createElement(S.Wrapper, { flush: "both" },
            React.createElement(S.Inner, null,
                React.createElement(S.Grid, null,
                    logo && (React.createElement(S.LogoHolder, { href: logo.url },
                        React.createElement(S.Logo, { alt: logo.title, loading: "lazy", src: logo.src, width: 250, height: 100 }))),
                    React.createElement(S.ContactHolder, null,
                        social && (React.createElement(S.SocialIconHolder, null, social?.map((icon) => (React.createElement(S.SocialLink, { key: icon.id, href: icon.url },
                            React.createElement(S.SocialIcon, { src: icon.icon.src, alt: icon.icon.altText })))))),
                        React.createElement(S.ContactCol, null,
                            email && (React.createElement(S.ContactLink, null,
                                React.createElement(S.Email, { href: `mailto:${email}` }, email))),
                            tel && (React.createElement(S.ContactLink, null,
                                React.createElement(S.TelNum, { href: `tel:${tel}` }, tel)))),
                        address && (React.createElement(S.ContactCol, null,
                            React.createElement(S.ContactAddress, { dangerouslySetInnerHTML: { __html: address } })))),
                    React.createElement(S.NavHolder, null,
                        nav && (React.createElement(S.Nav, null,
                            React.createElement(S.NavContainer, null, nav.map((item) => (React.createElement(S.NavLinkItem, { key: item.id },
                                React.createElement(S.NavItem, { href: item.url, target: item.target }, item.text))))))),
                        ctas && (React.createElement(S.CtaHolder, null, ctas.map((cta) => (cta.url ?
                            React.createElement(LinkButton, { key: cta.id, title: cta.text ? cta.text : '', branding: "secondary", href: cta.url, target: cta.target })
                            : null))))),
                    baseNav && (React.createElement(S.BaseNav, null,
                        React.createElement(S.BaseNavContainer, null, baseNav.map((item) => (React.createElement(S.BaseNavLinkItem, { key: item.id },
                            React.createElement(S.BaseNavItem, { href: item.url, target: item.target }, item.text))))))),
                    React.createElement(S.Copyright, null,
                        React.createElement(S.CopyrightContent, null, copyright)))))));
};
export default SiteFooter;
